import { Skeleton, Tabs, Typography } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PREFIX } from '@app/constants/appPrefix';

import { useEditUser, useEditUserEffects } from '@pages/Users/EditUser/hooks';

import '@pages/Users/EditUser/styles/EditUser.desktop.scss';
import '@pages/Users/EditUser/styles/EditUser.tablet.scss';

const { Text, Title } = Typography;

export const EditUser = () => {
  const {
    contextHolder,
    isLoadingPage,
    activeKey,
    handleTabClick,
    tabsItems,
    isDesktop,
    isForbiddenPage,
    userName,
    getDataHandler,
    initTab,
    getUserAccessRightsHandler,
  } = useEditUser();

  useEditUserEffects({
    getDataHandler,
    initTab,
    getUserAccessRightsHandler,
  });

  if (isLoadingPage) {
    return <Skeleton active />;
  }

  if (isForbiddenPage) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <div className={`${PREFIX}edit-user`}>
      {contextHolder}
      <div className="ant-tabs-nav">
        <Title
          level={4}
          className="mg-0"
          data-testid="user-position-menu-block"
        >
          Пользователь
        </Title>
        <Text strong data-testid="user-name-menu-block">
          {userName}
        </Text>
      </div>
      <Tabs
        className={`${PREFIX}global-tab-styles`}
        type={isDesktop ? 'line' : 'card'}
        tabPosition={isDesktop ? 'left' : 'top'}
        items={tabsItems}
        onTabClick={handleTabClick}
        activeKey={activeKey}
      />
    </div>
  );
};
